import styled from 'styled-components';
import { Box } from '@magalu/stereo-ui/atoms';
export const Container = styled(Box).attrs({
  borderRadius: 'circle',
  width: '24px',
  height: '24px',
  overflow: 'hidden'
})``;